<script>
    import { handleScoopAjaxError } from '../mixins/axios-response-errors'

    export default {
        props: {
            tree: Object,
            selected: Array,
        },
        data() {
            return {
                loading: false,
                index: null,
                directory: null,
                newDirectory: '',
                renameDirectory: '',
                msg: [],
            }
        },
        mounted() {
            this.setIndexAndDirectory(this.selected);

            this.$nextTick(() => {
                this.initializeTree();
            });
        },
        methods: {
            initializeTree() {
                $('#jstree-actions').jstree({
                    'plugins': ['dnd'],
                    'core': {
                        'themes': {
                            'name': 'proton',
                            'responsive': true
                        },
                        'multiple': false,
                        'check_callback': true
                    }
                });
                $('#jstree-actions').on("changed.jstree", function (e, data) {
                    if (data.node) {
                        this.setIndexAndDirectory(data.node.id);
                    }
                }.bind(this));
                $('#jstree-actions').on("move_node.jstree", function (e, data) {
                    this.moveDirectory(data);
                }.bind(this));
            },
            setIndexAndDirectory(json) {
                _.forEach(JSON.parse(json), (value, key) => {
                    this[key] = value || null;
                });
            },
            createDirectory() {
                this.loading = true;

                axios.post('/mediaserver/directory', {
                    newDirectory: this.newDirectory,
                    filter: {index: this.index, directory: this.directory},
                }).then((response) => {
                    if (response.data.success) {
                        this.newDirectory = '';

                        this.reloadWithDirectory((this.directory || '') + (this.newDirectory ? '::' + this.newDirectory : ''));
                    }
                });
            },
            updateDirectory() {
                this.loading = true;

                let path = this.directory.split('::');
                let oldDirectory = _.last(path);

                path[_.findLastIndex(path)] = this.renameDirectory;
                path = path.join('::');

                if (confirm('You are going to rename the directory from ' + oldDirectory + ' to ' + this.renameDirectory)) {
                    axios.post('/mediaserver/directory/update', {
                        renameDirectory: this.renameDirectory,
                        filter: {index: this.index, directory: this.directory},
                    }).then((response) => {
                        if (response.data.success) {
                            this.reloadWithDirectory(path);
                        }
                    }).catch(error => {
                        handleScoopAjaxError(error);
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                }
            },
            moveDirectory(data) {
                this.loading = true;

                let node = data.node;
                let parent = JSON.parse(data.parent);
                let oldParent = JSON.parse(data.old_parent);

                if (parent.index != oldParent.index) {
                    window.location.reload();
                    return;
                }

                let parentDirectory = parent.directory.split('::').join('/');
                let oldParentDirectory = oldParent.directory.split('::').join('/');

                if (confirm('You are going to move the directory "' + node.text + '"\nfrom ' + oldParentDirectory + ' to ' + parentDirectory + '\n')) {
                    axios.post('/mediaserver/directory/move', {
                        index: parent.index,
                        directory: node.data.labelWithoutCounts,
                        oldParent: oldParentDirectory,
                        newParent: parentDirectory,
                    }).then((response) => {
                        if (response.data.success) {
                            this.reloadWithDirectory(parentDirectory.split('/').join('::'));
                        }
                    }).catch(error => {
                        handleScoopAjaxError(error);
                        this.loading = false;
                    });
                } else {
                    window.location.reload();
                }
            },
            deleteDirectory() {
                this.loading = true;

                if (confirm('You are going to delete the directory:\n' + this.directoryReadable)) {
                    axios.post('/mediaserver/directory/destroy', {
                        index: this.index,
                        directory: this.directory
                    }).then(response => {
                        if (response.data.success) {
                            let directory = this.directory.split('::');
                            directory.pop();

                            this.reloadWithDirectory(directory.join('::'));
                        }
                    }).catch(error => {
                        handleScoopAjaxError(error);
                        this.loading = false;
                    })
                } else {
                    this.loading = false;
                }
            },
            reloadWithDirectory(directory) {
                axios.get('/mediaserver/directory').then((response) => {
                    this.$parent.tree = response.data;

                    let selected = JSON.parse(_.first(this.selected));
                    selected.directory = directory;
                    this.$parent.selected = [JSON.stringify(selected)];

                    this.loading = false;
                });
            },
            validateDirectory(value){
                if (/^[^/]*$/.test(value)) {
                    this.msg['renameDirectory'] = '';
                } else{
                    this.msg['renameDirectory'] = 'Invalid directory. Slash ("/") is not allowed!';
                }
            }
        },
        computed: {
            filteredTree() {
                return _.find(this.tree.children, node => {
                    node = JSON.parse(node.value);

                    return this.index === node.index;
                });
            },
            indexSelected() {
                return !_.isNull(this.index);
            },
            directorySelected() {
                return !_.isNull(this.directory);
            },
            directoryReadable() {
                let directory = this.index + (this.directory || '');

                return directory.split('::').join('/');
            },
            newDirectoryIsEmpty() {
                return this.newDirectory == '';
            },
            lastDirectory() {
                if (!this.directory) {
                    return '';
                }

                return _.last(this.directory.split('::'));
            },
            renameDirectoryHasError() {
                if(/^[^/]*$/.test(this.renameDirectory)) {
                    return '';
                }

                return 'hasError';
            },
        },
        watch: {
            directory() {
                this.renameDirectory = this.lastDirectory;
            },
            renameDirectory(value){
                // binding this to the data value in the email input
                this.renameDirectory = value;
                this.validateDirectory(value);
            },
            loading() {
                if (!this.loading) {
                    this.setIndexAndDirectory(this.selected);

                    this.$nextTick(() => {
                        this.initializeTree();
                    });
                }
            }
        }
    }
</script>

<template>
    <div>
        <Lightbox
                id="mediaDirectoryActions"
                headline="Directory actions"
                large="true"
                @lightboxclosing="$parent.fetchDirectories"
                :deactivated="!indexSelected"
        >
            <button type="button" slot="open-template" class="btn btn-primary btn-block btn-xs m-b-sm"
                    :class="{disabled: !indexSelected}">
                <span>Actions</span>
                <i class="fa fa-cogs" aria-hidden="true"></i>
            </button>
            <div slot="body" class="row m-b" v-if="loading">
                <div class="text-center p-m">
                    <span>Loading</span>
                    <i class="fa fa-cog fa-spin"></i>
                </div>
            </div>
            <div slot="body" class="row" v-else>
                <div class="col-md-6">
                    <div class="ibox">
                        <div class="ibox-title">
                            <strong>Directory:</strong>
                            <code>{{ directoryReadable }}</code>
                            <p class="m-b-none m-t-md">Drag &amp; Drop to move directories</p>
                        </div>
                        <div class="ibox-content">
                            <div id="jstree-actions">
                                <ul>
                                    <tree-node
                                            class="jstree-open"
                                            :node="filteredTree"
                                            :children-collapsed="true"
                                            :selected="selected"
                                            :show-counts="true"
                                            v-if="filteredTree"
                                    ></tree-node>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="ibox" v-show="indexSelected">
                        <div class="ibox-title"><h4>Create subdirectory</h4></div>
                        <div class="ibox-content">
                            <div class="row">
                                <div class="col-xs-10">
                                    <input class="form-control " type="text" v-model="newDirectory"
                                           @keydown.enter="createDirectory"/>
                                </div>
                                <button class="btn btn-primary col-xs-2" @click="createDirectory"
                                        :disabled="newDirectoryIsEmpty">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="ibox" v-show="directorySelected">
                        <div class="ibox-title"><h4>Rename directory</h4></div>
                        <div class="ibox-content">
                            <div class="row" :class="renameDirectoryHasError">
                                <div class="col-sm-10">
                                    <input class="form-control" type="text" v-model="renameDirectory"
                                           @keydown.enter="updateDirectory"/>
                                    <span v-if="msg.renameDirectory" class="form-info">{{msg.renameDirectory}}</span>
                                </div>
                                <button class="btn btn-primary col-sm-2" @click="updateDirectory"
                                        :disabled="renameDirectory == lastDirectory || renameDirectory =='' || msg.renameDirectory !=''">
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr>
                                    <button class="btn btn-danger btn-block btn-xs btn-outline"
                                            @click="deleteDirectory">
                                        <span>Delete directory</span>
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Lightbox>
    </div>
</template>
